module.exports = __webpack_public_path__ + "static/img/2bf00a299b73365bb04814a4be38bda0.fa67bf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2bf00a299b73365bb04814a4be38bda0.jpg
// module id = 7Z5j
// module chunks = 3